module.exports = __webpack_public_path__ + "static/media/icon-checks.3d26e57a.svg";